/**
 * PortaoPais — portao de acesso ao modo dos pais.
 *
 * Secao 13, Fase 6: segurar 3 segundos + uma conta. Os dois juntos, porque uma
 * crianca de 5 anos consegue segurar um botao por acidente, mas nao resolve
 * uma multiplicacao de dois digitos.
 *
 * Este portao NAO faz parte da sessao da crianca. Ele fica discreto num canto,
 * sem chamar atencao, e nada dele aparece durante uma tarefa.
 */

let estiloInjetado = false;

function injetarEstilo() {
  if (estiloInjetado) return;
  estiloInjetado = true;

  const estilo = document.createElement('style');
  estilo.textContent = `
    .portao-gatilho {
      position: fixed;
      right: 0;
      bottom: 0;
      width: 72px;
      height: 72px;
      border: none;
      background: transparent;
      cursor: default;
      z-index: 8;
      -webkit-tap-highlight-color: transparent;
    }
    .portao-painel {
      position: fixed;
      inset: 0;
      background: rgba(22, 26, 20, 0.92);
      color: #f3f3ee;
      font-family: system-ui, -apple-system, sans-serif;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 22px;
      z-index: 100;
    }
    .portao-painel h2 { font-size: 30px; margin: 0; font-weight: 600; }
    .portao-painel p { font-size: 22px; margin: 0; opacity: 0.75; }
    .portao-painel input {
      font-size: 34px;
      padding: 14px 20px;
      width: 200px;
      text-align: center;
      border-radius: 14px;
      border: 2px solid #6b7a5e;
      background: #fff;
      color: #222;
    }
    .portao-painel button {
      font-size: 22px;
      padding: 16px 34px;
      min-height: 60px;
      border-radius: 14px;
      border: none;
      background: #7cb342;
      color: #fff;
      cursor: pointer;
    }
    .portao-painel .portao-sair {
      background: transparent;
      border: 1px solid #6b7a5e;
      color: #cfd8c5;
    }
  `;
  document.head.appendChild(estilo);
}

const SEGURAR_MS = 3000;

export class PortaoPais {
  /** @param {Function} aoAbrir chamado quando o adulto passa pelo portao */
  constructor(aoAbrir) {
    injetarEstilo();
    this.aoAbrir = aoAbrir;
    this.temporizador = null;

    this.gatilho = document.createElement('button');
    this.gatilho.className = 'portao-gatilho';
    this.gatilho.setAttribute('aria-label', 'Area dos pais');
    this.gatilho.type = 'button';

    this.gatilho.addEventListener('pointerdown', () => this.comecarAContar());
    this.gatilho.addEventListener('pointerup', () => this.cancelar());
    this.gatilho.addEventListener('pointerleave', () => this.cancelar());

    document.body.appendChild(this.gatilho);
  }

  comecarAContar() {
    this.cancelar();
    this.temporizador = setTimeout(() => this.pedirConta(), SEGURAR_MS);
  }

  cancelar() {
    if (this.temporizador) clearTimeout(this.temporizador);
    this.temporizador = null;
  }

  pedirConta() {
    const a = 7 + Math.floor(Math.random() * 8); // 7..14
    const b = 6 + Math.floor(Math.random() * 8); // 6..13
    const resposta = a * b;

    const painel = document.createElement('div');
    painel.className = 'portao-painel';
    painel.innerHTML = `
      <h2>Area dos pais</h2>
      <p>Quanto e ${a} x ${b}?</p>
    `;

    const campo = document.createElement('input');
    campo.type = 'number';
    campo.setAttribute('inputmode', 'numeric');
    campo.setAttribute('aria-label', `Quanto e ${a} vezes ${b}`);
    painel.appendChild(campo);

    const confirmar = document.createElement('button');
    confirmar.textContent = 'Entrar';
    confirmar.type = 'button';
    painel.appendChild(confirmar);

    const sair = document.createElement('button');
    sair.textContent = 'Voltar para a fazenda';
    sair.className = 'portao-sair';
    sair.type = 'button';
    painel.appendChild(sair);

    const fechar = () => painel.remove();

    confirmar.addEventListener('click', () => {
      if (Number(campo.value) === resposta) {
        fechar();
        this.aoAbrir();
      } else {
        // Sem drama: e um adulto errando uma conta, nao uma crianca.
        campo.value = '';
        campo.focus();
      }
    });

    sair.addEventListener('click', fechar);

    document.body.appendChild(painel);
    campo.focus();
  }

  descartar() {
    this.cancelar();
    this.gatilho.remove();
  }
}
